import { useEffect, useRef, useState } from "react";
import "../App.css";
import { toast } from "react-toastify";
import { AddCircleOutlineRounded } from "@mui/icons-material";
import "./Section.css";
import addImageIcon from "../assets/icons/add-image.png";
import { TextField } from "@mui/material";
import { API } from "../assets/staticData";
import SelectLang from "../components/select-lang/SelectLang";
import HistorySliderDataTable from "../components/data-tables/HistorySliderDataTable";

let userToken = localStorage.getItem("userToken");

const headers = {
  Authorization: `Bearer ${userToken}`,
  "Content-Type": "application/json",
};

export default function HistorySlider({ user }) {
  const [error, setError] = useState(null);
  const [items, setItems] = useState([]);
  const [openAdd, setOpenAdd] = useState(false);
  const [refresh, setRefresh] = useState(false);
  const [image, setImage] = useState(null);
  const hiddenFileInput = useRef();
  const [lang, setLang] = useState("");
  const [data, setData] = useState({
    year: 0,
    title: "",
    desc: "",
    public: true,
  });

  useEffect(() => {
    async function getData() {
      fetch(`${API}/history-slides?populate=*`, {
        headers,
        method: "GET",
      }).then(async (res) => {
        const respone = await res.json();
        setItems(respone.data);
      });
    }

    getData();
  }, [refresh]);

  if (error) {
    // Print errors if any
    return <div>An error occured: {error.message}</div>;
  }

  const handleBannerDataChange = (field, value) => {
    setData({
      ...data,
      [field]: value,
    });
  };

  const handleImageChange = (e) => {
    const file = e.target.files[0];

    if (file) {
      setImage(file);
    }
  };

  const uploadImage = async (file) => {
    const imageFormData = new FormData();
    imageFormData.append("files", file);

    const response = await fetch(`${API}/upload`, {
      headers: {
        Authorization: `Bearer ${userToken}`,
      },
      method: "POST",
      body: imageFormData,
    });

    const result = await response.json();
    return result[0]?.url;
  };

  const uploadData = async () => {
    if (data.title !== "" && data.desc !== "" && data.year !== 0 && image !== null && lang !== "") {
      const imageUrl = await uploadImage(image);

      fetch(`${API}/history-slides`, {
        headers,
        method: "POST",
        body: JSON.stringify({
          data: {
            ...data,
            public: true,
            image: imageUrl,
            lang: lang,
          },
        }),
      })
        .then(() => {
          setData({ year: 0, title: "", desc: "", public: true });
          setImage(null);
          setOpenAdd(false);
          setRefresh(!refresh);
          toast("The Item was successfully added", {
            position: "top-center",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
          });
        })
        .catch((error) => setError(error));
    } else {
      toast("Please fill the required fields", {
        position: "top-center",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
        type: "error",
      });
    }
  };

  return (
    <div className="App">
      <div>
        <h3 style={{ textAlign: "start", marginBottom: 10 }}>History Slider Settings</h3>
        {user.perms[33].add && (
          <div className="addC" style={{ height: openAdd ? 460 : 50, padding: openAdd ? 20 : 0 }}>
            {openAdd && (
              <div
                className="addContent"
                style={{
                  marginTop: 10,
                  marginBottom: 60,
                  display: "flex",
                  width: "90%",
                  alignItems: "center",
                  justifyContent: "space-between",
                }}>
                <div style={{ width: "45%", height: "100%" }}>
                  <div>
                    <TextField
                      label="Title"
                      sx={{ width: "100%", mt: 2 }}
                      value={data.title}
                      onChange={(e) => handleBannerDataChange("title", e.target.value)}
                    />
                  </div>
                  <div>
                    <TextField
                      label="Description"
                      sx={{ width: "100%", mt: 2 }}
                      multiline
                      rows={4}
                      value={data.desc}
                      onChange={(e) => handleBannerDataChange("desc", e.target.value)}
                    />
                  </div>
                </div>
                <div style={{ width: "45%", height: "100%" }}>
                  <div>
                    <TextField
                      label="Year"
                      sx={{ width: "100%", mt: 2, mb: 2 }}
                      type="number"
                      value={data.year}
                      onChange={(e) => handleBannerDataChange("year", e.target.value)}
                    />
                  </div>

                  <SelectLang lang={lang} setLang={setLang} />

                  <div
                    style={{
                      border: "dashed",
                      borderWidth: 1,
                      borderColor: "grey",
                      height: "50%",
                      display: "flex",
                      alignItems: "center",
                      flexDirection: "column",
                      justifyContent: "center",
                      borderRadius: 5,
                      cursor: "pointer",
                      marginTop: 15,
                    }}
                    onClick={() => hiddenFileInput.current.click()}>
                    {image ? (
                      <img
                        src={URL.createObjectURL(image)}
                        style={{
                          width: 45,
                          aspectRatio: 1,
                          borderRadius: 55,
                          objectFit: "cover",
                        }}
                      />
                    ) : (
                      <img src={addImageIcon} style={{ width: 45 }} />
                    )}
                    <p style={{ color: "#888", fontSize: 13 }}>Click here to add an image</p>
                    <input
                      type="file"
                      accept="image/*"
                      onChange={handleImageChange}
                      ref={hiddenFileInput}
                      style={{ display: "none" }}
                    />
                  </div>
                </div>
              </div>
            )}
            <div
              className="addBTN"
              onClick={() => (openAdd ? uploadData() : setOpenAdd(true))}
              style={{ width: openAdd ? "50%" : "100%" }}>
              Add a new Slide
              <AddCircleOutlineRounded style={{ marginLeft: 7 }} />
            </div>
            {openAdd && (
              <div
                onClick={() => {
                  setOpenAdd(false);
                  setImage(null);
                }}
                className="cancelBTN">
                Cancel
              </div>
            )}
          </div>
        )}
        <HistorySliderDataTable
          data={items}
          user={user}
          endpoint={"history-slides"}
          setRefresh={setRefresh}
          refresh={refresh}
          permNumber={33}
        />
      </div>
    </div>
  );
}
